class StoresList extends HTMLElement {
  constructor() {
    super();
    this.api = window.storeApiUrl;
  }

  connectedCallback() {
    window.addEventListener("load", this.init.bind(this));
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this.onChange.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener("load", this.init.bind(this));
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this.onChange.bind(this));
  }

  init() {
    this.wrapper = this.closest('.product-info__block-item')
    this.variant = this.dataset.initial;
    this.textInStock = this.dataset.inStock;
    this.textOutStock = this.dataset.outStock;
    this.getStores()
  }

  onChange(e) {
    this.variant = e.detail?.variant?.id;
    this.getStores()
  }

  async getStores() {
    if (!this.variant) return;
    try {
      const stores = await fetch(this.api + this.variant)
        .then(r => r.json())
        .then(res => res?.[0]?.inventoryList || [])
        .catch(err => [])

      const fragment = document.createDocumentFragment()
      stores.forEach(store => {
        const storeEl = document.createElement('div')
        storeEl.classList.add('store-list-element')

        const nameLine = document.createElement('p')
        const parts = [store?.name, store?.city, store?.province_code].filter(v => v)
        nameLine.textContent = parts.join(', ')
        storeEl.appendChild(nameLine)

        const addressLine = document.createElement('p')
        addressLine.textContent = store?.address || ''
        storeEl.appendChild(addressLine)

        const status = document.createElement('div')
        status.classList.add('stock-status')
        const isOutOfStock = store?.availableToSell === '0.00'
        status.classList.add(isOutOfStock ? 'out-of-stock' : 'in-stock')
        status.textContent = isOutOfStock ? this.textOutStock : this.textInStock
        storeEl.appendChild(status)

        fragment.appendChild(storeEl)
      })
      this.textContent = ''
      this.appendChild(fragment)
      if (!this.wrapper) return;
      this.wrapper.style.display = stores.length === 0 ? 'none' : 'block';
    } catch (error) {
      console.error(error);
      if (this.wrapper) this.wrapper.style.display = 'none';
    }
  }
}

customElements.define('stores-list', StoresList);